import { SimpleModalId } from 'constants/modalId';
import { UnlockClipModalContentContainer } from './UnlockClipModalContentContainer';
import { makeGuardedModal } from 'components/guardedModal/makeGuardedModal';

export const UnlockClipModal = makeGuardedModal(SimpleModalId.UnlockClip, UnlockClipModalContentContainer);
